import React, { MouseEvent, ReactElement, useCallback } from 'react';
import isEqual from 'lodash.isequal';
import { useActiveLanguage } from 'b2b-apps/shop/i18n/hooks';
import { ROUTES } from 'b2b-apps/shop/routes/components/Router';
import { useRouterPush, useUrlCreator } from 'b2b-apps/shop/routes/hooks';
import { getCategoryUrlParams, openLink } from 'b2b-apps/shop/routes/utils/url';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

enum INK_CATEGORY_URL {
  de = '/computing-software/peripherie/tinte-toner',
  fr = '/fr/computing-logiciels/peripheriques/encre-toner',
}

enum PRINTERS_CATEGORY_URL {
  de = '/computing-software/peripherie/drucker',
  fr = '/computing-software/peripherie/drucker',
}

const withContainer = (
  Component: WrappedComponentType,
): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const push = useRouterPush();
    const urlCreator = useUrlCreator();
    const lang = useActiveLanguage();

    const url = `${urlCreator(ROUTES.category)}${getCategoryUrlParams(INK_CATEGORY_URL[lang])}`;

    const handleClick = useCallback(
      (e: MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        openLink(url, push);
      },
      [url, push],
    );

    const injectedProps: InjectedProps = {
      onClick: handleClick,
      url,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export {
  INK_CATEGORY_URL,
  PRINTERS_CATEGORY_URL,
  withContainer,
};
